export default __webpack_public_path__ + "static/media/coupons-active.59b01060.svg";